import instance from 'api';
import { AxiosError, AxiosResponse } from 'axios';
import { ApiResponse, BaseApi } from 'baseApi';
import { endpoints } from 'endpoints.config';
import { FreeTrialSubscriptionParser } from 'pages/subscribeFreeTrial/models';

const UNKNOWN_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again.';

export class AddFreeTrialApi extends BaseApi {
  // get free trial subscription packages
  public static getPackages = async (): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.get(
        endpoints.subscriptions.getSubscriptionsFreeTrial
      );

      if (AddFreeTrialApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return AddFreeTrialApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = FreeTrialSubscriptionParser.parseError(errors);
          return AddFreeTrialApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = FreeTrialSubscriptionParser.parseError(errors);
          return AddFreeTrialApi.errorResponse(message);
        }
      }
      return AddFreeTrialApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  };

  public static submitFreeTrialPackages = async (
    selectedPackages: number[]
  ): Promise<any> => {
    try {
      const payload = { packageIDs: selectedPackages };

      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.subscriptions.subscribeFreeTrial,
        payload
      );

      if (AddFreeTrialApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return AddFreeTrialApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = FreeTrialSubscriptionParser.parseError(errors);
          return AddFreeTrialApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = FreeTrialSubscriptionParser.parseError(errors);
          return AddFreeTrialApi.errorResponse(message);
        }
      }
      return AddFreeTrialApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  };
}
